import Vue from 'vue';
import Vuex from 'vuex';
import {setImage, shoppingCartlist, area_list, copyRight, fetchStoreData, fetchUnreadCount} from '../api/xunyou';

Vue.use(Vuex);

// 计算购物车中SKU列表
const getCartSkus = (storeList) => {
  const list = [];
  if (storeList && storeList.length) {
    storeList.forEach(ele => {
      if (ele.bxunyouMerchant) {
        list.push(...ele.bxunyouMerchant.goods);
      }
    })
  }
  return list;
};

export default new Vuex.Store({
  state: {
    staticPath:'https://wx.itensent.com/wap/file/static',
    imToken: localStorage.getItem('imToken') || '',
    userInfo: localStorage.getItem('userInfo') ? JSON.parse(localStorage.getItem('userInfo')) : '',
    getprovince: sessionStorage.getItem('areas') ? JSON.parse(sessionStorage.getItem('areas')) : [], // 地址联动
    selectedGoodsFromCart: sessionStorage.getItem('selectedGoodsFromCart') ? JSON.parse(sessionStorage.getItem('selectedGoodsFromCart')) : [],
    payOrderNos: sessionStorage.getItem('payOrderNos') ? JSON.parse(sessionStorage.getItem('payOrderNos')) : [],
    isShowNav: true,
    gotRedPack: [],
    currentAddress: {},
    erweimaUrl: '',
    carts: [],
    logo: null,
    copyrights: '',
    applyStoreData: null,
    countData: {
      msgCount: 0,
      noticeCount: 0
    }
  },
  mutations: {
    // 登录
    login(state, user) {
      state.userInfo = user;
      localStorage.setItem('userInfo', JSON.stringify(user));
    },
    // 退出
    logout(state) {
      state.userInfo = '';
      state.applyStoreData = null;
      state.imToken = null;
      localStorage.removeItem('userInfo');
      localStorage.removeItem('imToken');
    },
    // 保存im token
    SAVE_IM_TOKEN (state, imToken) {
      state.imToken = imToken;
      localStorage.setItem('imToken', imToken);
    },
    // 地址
    SAVE_AREA_LIST(state, param) {
      state.getprovince = param;
      sessionStorage.setItem('areas', JSON.stringify(param));
    },
    // 是否展示导航栏
    getisShowNav(state, param) {
      state.isShowNav = param
    },
    //  已领取的 为了做对比,防止多次领取
    gotRedPackred(state, param) {
      console.log(state, param, '防止多次领取')
      state.gotRedPack = param
    },
    //  记录当前的位置
    gotCurrentAddress(state, param) {
      state.currentAddress = param
      console.log(state.currentAddress, '记录当前的位置')
    },
    // 获取微信二维码
    SAVE_WX_QRCODE: (state, param) => {
      state.erweimaUrl = param
      console.log(state.erweimaUrl, '二维码')
    },
    // 保存购物车列表
    SAVE_CARTS: (state, list) => {
      state.carts = list;
    },
    // 保存logo
    SAVE_LOGO: (state, logo) => {
      state.logo = logo;
    },
    // 保存版权信息
    SAVE_COPYRIGHTS: (state, data) => {
      state.copyrights = data;
    },
    // 保存购物车选择下单的商品
    SAVE_SELECTED_GOODS: (state, goods) => {
      state.selectedGoodsFromCart = goods;
      sessionStorage.setItem('selectedGoodsFromCart', JSON.stringify(goods));
    },
    // 保存下单页面信息，到支付页面展示
    SAVE_PAY_ORDER: (state, data) => {
      state.payOrderNos = data;
      sessionStorage.setItem('payOrderNos', JSON.stringify(data));
    },
    // 保存店铺审核信息
    SAVE_STORE_APPLY_DATA (state, data) {
      state.applyStoreData = data;
    },
    SAVE_UNREAD_COUNT (state, counts) {
      state.countData = counts;
    }
  },
  actions: {
    // 获取地址数据
    getAreaList ({commit, state, getters}) {
      if (state.getprovince.length) return ;
      area_list().then(res => {
        console.log('地址数据：', res);
        if (res.code === 0 && res.data) {
          commit('SAVE_AREA_LIST',res.data);
        }
      }).catch(err => {
        this.$message.error('获取地址失败，请稍后再试！')
      })
    },
    // 获取购物车列表
    getCartList ({commit, state, getters}) {
      if (!getters.userId) return ;
      shoppingCartlist({ uid: getters.userId })
        .then(res => {
          console.log('购物车列表：', res);
          if (res.code === 0) {
            commit('SAVE_CARTS', res.data);
          }
        });
    },
    // 获取logo
    getLogo({commit, state, getters}) {
      setImage().then(res => {
        console.log('logo图片', res);
        if (res.code === 0) {
          const logo = res.rows.length && res.rows[0].pcLogo ? res.rows[0].pcLogo : require('../assets/images/logo.jpg');
          commit('SAVE_LOGO', logo);
        }
      })
    },
    // 获取版权信息
    getCopyrights ({ commit }) {
      copyRight().then(res => {
        console.log('版权信息：', res);
        if (res.code === 0) {
          const copyrights = res.rows ? res.rows[0] : null
          commit('SAVE_COPYRIGHTS', copyrights);
        }
      }).catch(err => {
        this.$message.error('查询失败,请稍后再试!')
      })
    },
    // 店铺状态
    getStoreData ({ commit, state, getters }, callback) {
      if (!getters.isLogin) return;
      fetchStoreData({ sellerAccount: state.userInfo.loginName})
        .then(res => {
          console.log('店铺申请审核信息：', res);
          if (res.code === 0) {
            commit('SAVE_STORE_APPLY_DATA', res.data);
          }
        }).catch(err => {
          console.log('错误：', err);
      }).finally(() => {
        callback && callback();
      });
    },
    // 消息未读条数
    getUnreadCount ({ commit, getters }) {
      if (!getters.isLogin) return;
      // fetchUnreadCount().then(res => {
      //   console.log('未读条数：', res);
      //   if (res.code === '200') {
      //     commit('SAVE_UNREAD_COUNT', {
      //       msgCount: res.data.unreadCount,
      //       noticeCount: res.data.unNoticeReadCount
      //     })
      //   }
      // });
    }
  },
  getters: {
    imToken: state => state.imToken,
    isLogin: state => !!state.userInfo,
    isMerchant: state => state.userInfo && state.userInfo.mid,
    userId: state => state.userInfo.userId || 0,
    userAvatar: state => state.userInfo ? state.userInfo.avatar : '/static/layui/images/0.jpg',
    cartSkus: state => getCartSkus(state.carts),
    accountTotal: (state, getters) => {
      return getters.cartSkus.reduce((sum, item) => {
        return sum + item.realprice * item.number;
      }, 0);
    },
    totalNumber: (state, getters) => {
      return getters.cartSkus.reduce((sum, item) => {
        return sum + item.number;
      }, 0);
    }
  }
})



// WEBPACK FOOTER //
// ./src/vuex/store.js